import client from "apis/config";

export const getDepositRequestApi = async (page = 1, limit = 10) => {
  return await client.get(`dashboard/deposits?page=${page}&limit=${limit}`);
};

export const acceptDeclineDepositRequestApi = async (paylaod) => {
  return await client.post(`dashboard/deposits/action`, paylaod);
};
